import { render } from "./FilteredVenues.vue?vue&type=template&id=23c67708"
import script from "./FilteredVenues.vue?vue&type=script&lang=js"
export * from "./FilteredVenues.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__